export default function generateBarplot(
    {
        track,
        divId,
        percentView,
        sampleMeta,
        trackDetails,
        cohortSelected,
        stratifyVar
    }
) {
    const Plotly = window.Plotly

    let data = []
    console.log('barplotlyjs sampleMeta', sampleMeta)
    var sampleMeta_showing = Object.fromEntries(
                                Object.entries(sampleMeta).filter(([, meta]) => cohortSelected.includes(meta.cohort))
                            )
    console.log('barplotlyjs sampleMeta_showing', sampleMeta_showing)
    const response = getlabel_byVar({sampleMeta_data: sampleMeta_showing, 
                                    stratifyVar: stratifyVar.VarName}, stratifyVar.class1).length
    const nonresponse = getlabel_byVar({sampleMeta_data: sampleMeta_showing,
                                        stratifyVar: stratifyVar.VarName}, stratifyVar.class2).length
    const totalAll = response + nonresponse
    if ((track === 'response') || (track === 'tissue_level') ) {
        trackDetails[track].forEach((category) => {
            const categoryLabel = category.label
            const response_track = getCohort_Label_byVar({ 
                sampleMeta_data: sampleMeta_showing, 
                track: track, 
                categoryLabel: categoryLabel,
                stratifyVar: stratifyVar.VarName,
            }, stratifyVar.class1).length
            const nonresponse_track = getCohort_Label_byVar({ 
                sampleMeta_data: sampleMeta_showing, 
                track: track, 
                categoryLabel: categoryLabel,
                stratifyVar: stratifyVar.VarName,
            }, stratifyVar.class2).length
            
            const total = response_track + nonresponse_track

            let yValue, yValueText

            

            if (percentView) {
                yValue = [
                    total/totalAll * 100, 
                    // Math.round(response_track/response * 100), 
                    // Math.round(nonresponse_track/nonresponse * 100)
                ]
                yValueText = yValue.map(el => `${Math.round(el)} %`)
            } else {
                yValue = [
                    total,
                    // response_track,
                    // nonresponse_track,
                ]
                yValueText = yValue.map(el => `${el}`)
            }
            let responseLabel = 'NaN'
            if (categoryLabel === 'R') {
                responseLabel = 'Responsive<br>(PFS ≥ 6 months)'
            } else if (categoryLabel === 'NR') {
                responseLabel = 'Non-responsive<br>(PFS < 6 months)'
            } else (
                responseLabel = categoryLabel
            )
            let trace = {
                            x: ['total'],
                            y: yValue,
                            text: yValueText,
                            name: responseLabel,
                            type: 'bar',
                            marker: { color: category.color }
                        }

            // let xytest_dict = {}
            // if (categoryLabel === 'response') {
            //     xytest_dict = {
            //                     x: ['total'],
            //                     y: yValue[0],
            //                     text: yValueText[0],
                                
            //                 }
            // } else {
            //     xytest_dict  = {
            //         x: ['total', 'Response', 'Non-response'],
            //         y: yValue,
            //         text: yValueText,
            //       }
            // }
            // let trace = {...traceTemplate, ...xytest_dict}

            data.push(trace)
        })

    } else {
        trackDetails[track].forEach((category) => {
            const categoryLabel = category.label
            const response_track = getCohort_Label_byVar({ 
                sampleMeta_data: sampleMeta_showing, 
                track: track, 
                categoryLabel: categoryLabel,
                stratifyVar: stratifyVar.VarName
            }, stratifyVar.class1).length
            const nonresponse_track = getCohort_Label_byVar({ 
                sampleMeta_data: sampleMeta_showing, 
                track: track, 
                categoryLabel: categoryLabel,
                stratifyVar: stratifyVar.VarName
            }, stratifyVar.class2).length
            
            const total = response_track + nonresponse_track

            let yValue, yValueText

            

            if (percentView) {
                yValue = [
                    total/totalAll * 100, 
                    response_track/response * 100, 
                    nonresponse_track/nonresponse * 100
                ]
                yValueText = yValue.map(el => `${Math.round(el)} %`)
            } else {
                yValue = [
                    total,
                    response_track,
                    nonresponse_track,
                ]
                yValueText = yValue.map(el => `${el}`)
            }

            let trace = {
                            x: ['total', stratifyVar.class1_name, stratifyVar.class2_name],
                            y: yValue,
                            text: yValueText,
                            name: categoryLabel,
                            type: 'bar',
                            marker: { color: category.color }
                        }

            // let xytest_dict = {}
            // if (categoryLabel === 'response') {
            //     xytest_dict = {
            //                     x: ['total'],
            //                     y: yValue[0],
            //                     text: yValueText[0],
                                
            //                 }
            // } else {
            //     xytest_dict  = {
            //         x: ['total', 'Response', 'Non-response'],
            //         y: yValue,
            //         text: yValueText,
            //       }
            // }
            // let trace = {...traceTemplate, ...xytest_dict}

            data.push(trace)
        })
    }  
    data.reverse()

    var layout = {
        width: 340,
        barmode: 'stack',
        title: track,
        legend: {
            orientation: 'v',
            // traceorder: 'reversed',
        },
        margin: {
            autoexpand: false,
            t: 50,
            r: 150,
        }
    }
      
    Plotly.newPlot(divId, data, layout);
}

// function getCohortCCRCC({ sampleMeta, track, categoryLabel }) {
//     return Object.entries(sampleMeta)
//         .filter(([, meta]) =>  meta.tumorClass === 'ccRCC' && 
//             meta[track] === categoryLabel)
//         .map(([sample, ]) => sample)
// }

// function getCohortnonCCRCC({ sampleMeta, track, categoryLabel }) {
//     return Object.entries(sampleMeta)
//         .filter(([, meta]) =>  meta.tumorClass !== 'ccRCC' 
//             && meta[track] === categoryLabel)
//         .map(([sample, ]) => sample)
// }

// function getCCRCC({ sampleMeta }) {
//     return Object.entries(sampleMeta)
//         .filter(([, meta]) =>  meta.tumorClass === 'ccRCC')
//         .map(([sample, ]) => sample)
// }

// function getnonCCRCC({ sampleMeta }) {
//     return Object.entries(sampleMeta)
//         .filter(([, meta]) =>  meta.tumorClass !== 'ccRCC')
//         .map(([sample, ]) => sample)
// }

function getCohort_Label({ sampleMeta_data, track, categoryLabel }, dx_label) {
    return Object.entries(sampleMeta_data)
        .filter(([, meta]) =>  meta.response == dx_label && 
            meta[track] === categoryLabel)
        .map(([sample, ]) => sample)
}


function getlabel({ sampleMeta_data }, label) {
    return Object.entries(sampleMeta_data)
        .filter(([, meta]) =>  meta.response == label)
        .map(([sample, ]) => sample)
}

function getCohort_Label_byVar({ sampleMeta_data, track, categoryLabel, stratifyVar }, dx_label) {
    return Object.entries(sampleMeta_data)
        .filter(([, meta]) =>  meta[stratifyVar] == dx_label && 
            meta[track] === categoryLabel)
        .map(([sample, ]) => sample)
}


function getlabel_byVar({ sampleMeta_data, stratifyVar }, label) {
    return Object.entries(sampleMeta_data)
        .filter(([, meta]) =>  meta[stratifyVar] == label)
        .map(([sample, ]) => sample)
}